import React, { useState, useEffect } from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment";
import { Box, Typography, Button } from "@material-ui/core";

import { MutantApiService } from "../../../../services/MutantApiService";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import store from "../../../../store/store";
import { Link } from "react-router-dom";
const dateTimeFormat = "DD/MM/YYYY";
let initialState = {};

export default function SettingsManagerForm(props) {
	const { auth } = store.getState();
	const [state, setState] = useState({
		id: 0,
		expiresAt: moment(new Date()).format(dateTimeFormat),
		isLoading: false,
		userLogged: auth.user,
		nodesLimitForStreaming: 0,
		usersPerNodeLimit: 0,
		nodePoolsLimitForFileSynthesis: 0,
		nodesPerNodePoolLimitForFileSynthesis: 0,
		audioVolumeControl: 1.0,
		audioStartEndTime: 0,
		audioEndTime: 0,
		enableGpuFileSynthesis: false,
		limitOfLinesOnFileForGpu: 100,
		limitOfSessionsForGpuFileSynthesis: 10,
		maintenanceMode: false,
	});

	const api = new MutantApiService();

	useEffect(() => {
		setState(prevState => ({
			...prevState,
			isLoading: true,
			isEditing: false
		}));

		loadData();
		return () => {
			initialState = {};
		};
	}, []);

	const loadData = async () => {
		const settings = await api.makeHttpRequest({
			url: `/settings`,
			method: "GET"
		});
		setState({
			nodesLimitForStreaming: settings.nodesLimitForStreaming || 0,
			usersPerNodeLimit: settings.usersPerNodeLimit || 0,
			nodePoolsLimitForFileSynthesis:
				settings.nodePoolsLimitForFileSynthesis || 0,
			nodesPerNodePoolLimitForFileSynthesis:
				settings.nodesPerNodePoolLimitForFileSynthesis || 0,
			audioVolumeControl: settings.audioVolumeControl || 1.0,
			audioStartEndTime: settings.audioStartEndTime || 0,
			enableGpuFileSynthesis: settings.enableGpuFileSynthesis || false,
			limitOfLinesOnFileForGpu: settings.limitOfLinesOnFileForGpu || 100,
			limitOfSessionsForGpuFileSynthesis:
				settings.limitOfSessionsForGpuFileSynthesis || 10,
			isLoading: false,
			apiData: settings,
			maintenanceMode: settings.maintenanceMode || false
		});
	};

	const handleChange = e => {
		const { name, value } = e.target;

		if (value === "") {
			setState(prevState => ({
				...prevState,
				[name]: value
			}));
			return;
		}

		const numericValue = parseFloat(value);
		if (!isNaN(numericValue)) {
			setState(prevState => ({
				...prevState,
				[name]: numericValue
			}));
		}
	};

	const onCleanForm = async () => {
		setState(prevState => ({ ...prevState, isLoading: true }));
		try {
			await loadData();
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao reverter as alterações, tente mais tarde",
				"error"
			);
		}
		setState(prevState => ({ ...prevState, isLoading: false }));
	};

	const submit = async e => {
		e.preventDefault();
		setState(prevState => ({ ...prevState, isLoading: true }));

		try {
			const reqBase = { method: "PATCH", url: `/settings` };
			const reqData = {
				nodesLimitForStreaming: parseInt(state.nodesLimitForStreaming || 0),
				usersPerNodeLimit: parseInt(state.usersPerNodeLimit || 0),
				nodePoolsLimitForFileSynthesis: parseInt(
					state.nodePoolsLimitForFileSynthesis || 0
				),
				nodesPerNodePoolLimitForFileSynthesis: parseInt(
					state.nodesPerNodePoolLimitForFileSynthesis || 0
				),
				audioVolumeControl: parseFloat(state.audioVolumeControl || 1.0),
				audioStartEndTime: parseInt(state.audioStartEndTime || 0),
				enableGpuFileSynthesis: state.enableGpuFileSynthesis,
				limitOfLinesOnFileForGpu: parseInt(
					state.limitOfLinesOnFileForGpu || 100
				),
				limitOfSessionsForGpuFileSynthesis: parseInt(
					state.limitOfSessionsForGpuFileSynthesis || 10
				),
				maintenanceMode: state.maintenanceMode
			};
			
			await api.makeHttpRequest({
				...reqBase,
				data: {
					...state.apiData,
					...reqData
				}
			});
			afterSubmit();
		} catch (e) {
			Swal.fire(
				"Erro!",
				e?.response?.data
					? e.response.data.message
					: "Erro ao cadastrar cliente, tente novamente mais tarde.",
				"error"
			);
			setState(prevState => ({ ...prevState, isLoading: false }));
		}
	};

	const afterSubmit = async () => {
		setState(initialState);
		await Swal.fire({
			title: "Sucesso!",
			text: "Dados salvos com sucesso.",
			icon: "success",
			confirmButtonText: "Ok"
		});
		window.location.reload();
	};

	const formIsValid = () => {
		return (
			state.nodesLimitForStreaming >= 0 &&
			state.usersPerNodeLimit >= 0 &&
			state.nodePoolsLimitForFileSynthesis >= 0 &&
			state.nodesPerNodePoolLimitForFileSynthesis >= 0 &&
			state.audioVolumeControl >= 0 &&
			state.audioStartEndTime >= 0 &&
			(!state.audioEndTime || state.audioEndTime >= 0)
		);
	};

	window.setPageTitle("Cadastro de Configurações - Admin");

	return (
		<>
			<Loading isLoading={state.isLoading} />
			<AdminTitle title="Configurações" disableHeader />
			<Card className="mt-4">
				<StyledCardBody>
					<Form style={{ flex: "1" }}>
						<Form.Row>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="nodesLimitForStreaming"
									label="Limite de nós para streaming (Inteiro)"
									placeholder="Limite de nós para streaming"
									value={`${state.nodesLimitForStreaming}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="usersPerNodeLimit"
									label="Limite de usuários por nó (Inteiro)"
									placeholder="Limite de usuários por nó"
									value={`${state.usersPerNodeLimit}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="nodePoolsLimitForFileSynthesis"
									label="Limite de pools de nós para sintetização de arquivos (Inteiro)"
									placeholder="Limite de pools de nós para sintetização de arquivos"
									value={`${state.nodePoolsLimitForFileSynthesis}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="nodesPerNodePoolLimitForFileSynthesis"
									label="Limite de nós por pool de nós para sintetização de arquivos (Inteiro)"
									placeholder="Limite de nós por pool de nós para sintetização de arquivos"
									value={`${state.nodesPerNodePoolLimitForFileSynthesis}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="audioVolumeControl"
									label="Controle de volume do áudio (Decibéis)"
									placeholder="Controle de volume do áudio"
									value={`${state.audioVolumeControl}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
							<Form.Group as={Col} lg="6" xs="12">
								<InputField
									type="number"
									name="audioStartEndTime"
									label="Tempo de inicio e fim entre silêncios do áudio (Milisegundos)"
									placeholder="Tempo de inicio e fim entre silêncios do áudio"
									value={`${state.audioStartEndTime}`}
									onChange={handleChange}
									min={0}
								/>
							</Form.Group>
						</Form.Row>
						<Box
							border={1}
							borderRadius={5}
							style={{ padding: "10px", marginBottom: "10px" }}
						>
							<Typography
								variant="h6"
								gutterBottom
								style={{ marginBottom: "15px" }}
							>
								Arquivos com GPU
							</Typography>
							<Form.Row>
								<Form.Group as={Col} lg="6" xs="12">
									<InputField
										type="number"
										name="limitOfLinesOnFileForGpu"
										label="Limite de linhas para sintetização de arquivos com GPU (Inteiro)"
										placeholder="Limite de linhas para sintetização de arquivos com GPU"
										value={`${state.limitOfLinesOnFileForGpu}`}
										onChange={handleChange}
										min={0}
										disabled={!state.enableGpuFileSynthesis}
									/>
								</Form.Group>
								<Form.Group as={Col} lg="6" xs="12">
									<InputField
										type="number"
										name="limitOfSessionsForGpuFileSynthesis"
										label="Limite de sessões para sintetização de arquivos com GPU (Inteiro)"
										placeholder="Limite de sessões para sintetização de arquivos com GPU"
										value={`${state.limitOfSessionsForGpuFileSynthesis}`}
										onChange={handleChange}
										min={0}
										disabled={!state.enableGpuFileSynthesis}
									/>
								</Form.Group>
							</Form.Row>
							<Form.Row>
								<Form.Group as={Col} lg="6" xs="12">
									<Form.Check
										type="checkbox"
										name="enableGpuFileSynthesis"
										label="Permitir sintetização de arquivos com GPU"
										checked={state.enableGpuFileSynthesis}
										onChange={e =>
											setState(prevState => ({
												...prevState,
												enableGpuFileSynthesis: !prevState.enableGpuFileSynthesis
											}))
										}
									/>
								</Form.Group>
							</Form.Row>
						</Box>
						<Box
							border={1}
							borderRadius={5}
							style={{
								padding: "10px",
								marginBottom: "10px",
								marginTop: "10px",
								display: "flex",
								alignItems: "middle",
								vAlign: "middle",
								justifyContent: "around",
								paddingBottom: "20px"
							}}
						>
							<Form.Row
								style={{
									display: "flex",
									flexDirection: "row",
									width: "100%",
									minWidth: "100%",
								}}
							>
								<Form.Group as={Col} lg="6" xs="6">
									<Form.Check
										type="checkbox"
										name="maintenanceMode"
										label="Modo de manutenção"
										checked={state.maintenanceMode}
										style={{
											marginTop: "10px",
											display: "block",
											width: "400px",
											borderRadius: "5px",
											padding: "10px",
											textAlign: "center",
											fontSize: "16px",
											fontWeight: "bold",
										}}
										onChange={e =>
											setState(prevState => ({
												...prevState,
												maintenanceMode: !prevState.maintenanceMode
											}))
										}
									/>
								</Form.Group>
								<Form.Group as={Col} lg="6" xs="6">
									<Link
										variant="outline-danger"
										style={{
											marginTop: "10px",
											display: "block",
											width: "400px",
											backgroundColor: "#9036F7",
											color: "#fff",
											borderRadius: "5px",
											padding: "10px",
											textAlign: "center",
											fontSize: "16px",
											fontWeight: "bold",
										}}
										// onClick={e => {
										// 	e.preventDefault();
										// 	window.location.href = "/dashboard/maintenance-settings";
										// }}
										to="/dashboard/maintenance-settings"
									>
										Editar informações sobre manutenção
									</Link>
								</Form.Group>
							</Form.Row>
						</Box>
					</Form>
				</StyledCardBody>
			</Card>
			<FormActions
				module="settings"
				isEdit={false}
				formIsValid={formIsValid()}
				onCleanForm={onCleanForm}
				onSubmit={submit}
				hideReload
			/>
		</>
	);
}

export { SettingsManagerForm };
